module.exports = __webpack_public_path__ + "static/media/buidlboxProfile.05b4699c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buidlboxProfile.png
// module id = 751
// module chunks = 1 3